// src/components/trending/PolicySupportChart.jsx

import React from 'react';
import '../../styles/trending/PolicySupport.css';

const PolicySupportChart = ({ policies }) => {
  // Sort policies by support percentage in descending order
  const sortedPolicies = [...policies].sort((a, b) => b.supportPercentage - a.supportPercentage);
  
  // Get top 4 policies
  const topPolicies = sortedPolicies.slice(0, 4);
  
  return (
    <div className="policy-support-chart">
      {topPolicies.map((policy) => (
        <div key={policy.topic_id} className="policy-row">
          <div className="policy-label">{policy.statement}</div>
          <div className="policy-bar-container">
            <div 
              className="policy-support-bar" 
              style={{ 
                width: `${policy.supportPercentage}%`,
                backgroundColor: '#08773c' // Australian green
              }}
            />
            <div 
              className="policy-oppose-bar" 
              style={{ 
                width: `${policy.opposePercentage}%`,
                backgroundColor: '#f5f5f5' 
              }}
            />
          </div>
          <div className="policy-percentage">
            {policy.supportPercentage}% Support
          </div>
        </div>
      ))}
    </div>
  );
};

export default PolicySupportChart;